var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: ["error-cnt", { "gop-cnt": _vm.isGopRoute }] },
    [
      _c("h1", { staticClass: "error-text-404" }, [_vm._v("404")]),
      _c("h2", { staticClass: "error-text" }, [
        _vm._v(_vm._s(_vm.$t("errorPage.pageNotFound")))
      ]),
      _c("span", { staticClass: "subtext" }, [
        _vm._v(_vm._s(_vm.$t("errorPage.message")))
      ]),
      _c(
        "div",
        { staticClass: "button-group" },
        [
          _c(
            "div",
            {
              staticClass: "project-report-button-cnt",
              on: { click: _vm.handleContactButton }
            },
            [
              _c("img", {
                attrs: {
                  src: require("@/drc/assets/icons/report-problem2.svg"),
                  alt: "warning-sign"
                }
              }),
              _c("h4", [_vm._v(_vm._s(_vm.$t("errorPage.reportAProblem")))])
            ]
          ),
          _c(
            "router-link",
            {
              staticClass: "btn-filled",
              attrs: {
                tag: "button",
                to: `${_vm.isGopRoute ? "/gop/home" : "/home"}`
              }
            },
            [_vm._v(" " + _vm._s(_vm.$t("errorPage.toHomePage")) + " ")]
          )
        ],
        1
      ),
      _vm.showSendReportDialog
        ? _c("ReportAProblem", {
            attrs: {
              title: `${_vm.$t("projectPage.what")}`,
              sending: _vm.sending
            },
            on: {
              closeDialog: function($event) {
                _vm.showSendReportDialog = false
              },
              handleMessage: _vm.sendEmailForProblem
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }